import { Button, Col, Row } from "antd"
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout, ModalKitsProducts } from "../../../shared/components"
import { WrapperCardKits } from "./styled"
import { useKitsProducts } from "../hooks";
import { TableKitsProducts } from "./TableKitsProducts";


export const KitsProducts = () => {
    const { modalIsOpen, setModalIsOpen } = useKitsProducts()
  return (
    <AdminMenuLayout pageDescription="KitsProducts" title="Productos del kit">
        <WrapperCardKits>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
                onClick={()=>setModalIsOpen(true)}
            >
              Agregar producto al kit
            </Button>
          </Col>
        </Row>
        <TableKitsProducts />
        {
            modalIsOpen && ( <ModalKitsProducts  setModalIsOpen={setModalIsOpen} modalIsOpen={modalIsOpen} /> )
        }
        </WrapperCardKits>
    </AdminMenuLayout>
  )
}
